<template>
  <b-modal v-model="isActive" :title="modalTitle" @close="closeMenu">
    <div>
      <header class="modal-card-head">
        <p class="modal-card-title">{{ modalTitle }}</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>

      <div class="modal-card-body">
        <div class="awards-grid">
          <div
            v-for="award in allAwards"
            :key="award.code"
            class="award-item"
            :class="{ 'award-item--selected': studentHasAward(award.code) }"
            @click="selectAward(award)"
            @mouseenter="hoveredAward = award.code"
            @mouseleave="hoveredAward = null"
          >
            <img
              :src="require(`@/assets/img/awards/${award.icon}`)"
              :alt="award.name"
              class="award-icon"
            />
            <span class="award-name">{{ award.name }}</span>
            <div v-if="studentHasAward(award.code)">
              <span v-if="hoveredAward !== award.code" class="award-status">
                ✓
              </span>

              <button
                v-else
                type="button"
                class="delete is-danger"
                title="Remove award"
                @click.stop="removeAward(award)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { AWARDS } from "@/constants";

export default {
  name: "AwardsMenu",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      hoveredAward: null,
    };
  },

  computed: {
    allAwards() {
      return AWARDS;
    },

    isActive: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.closeMenu();
        }
      },
    },

    modalTitle() {
      if (this.student) {
        return `${this.student.firstName} ${this.student.lastName}'s awards`;
      }
      return "Awards";
    },
  },

  methods: {
    studentHasAward(awardCode) {
      return (
        this.student &&
        this.student.awards &&
        this.student.awards.includes(awardCode)
      );
    },

    selectAward(award) {
      if (!this.studentHasAward(award.code)) {
        // Student doesn't have this award - add it
        this.$emit("award-selected", {
          award,
          student: this.student,
        });
        this.closeMenu();
      }
      // If student already has the award, do nothing (removal is handled by removeAward)
    },

    removeAward(award) {
      this.$emit("award-removed", {
        award,
        student: this.student,
      });
      this.closeMenu();
    },

    closeMenu() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-card-body {
  padding: 1rem;
}

.awards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 0.5rem;
}

.award-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: 1px solid transparent;
}

.award-item:hover {
  background-color: #f0f0f0;
  border-color: #ddd;
}

.award-item--selected {
  background-color: #e8f5e8;
  border-color: #4caf50;
}

.award-item--selected:hover {
  background-color: #fff3cd;
  border-color: #ffc107;
}

.award-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}

.award-name {
  font-size: 13px;
  color: #333;
  flex: 1;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.award-status {
  font-size: 16px;
  color: #4caf50;
  font-weight: bold;
  margin-left: 8px;
  flex-shrink: 0;
}

.award-remove {
  background: #ff4757;
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  height: 20px;
  line-height: 1;
  margin-left: 8px;
  padding: 0;
  transition: background-color 0.2s ease;
  width: 20px;
  flex-shrink: 0;
}

.award-remove:hover {
  background: #ff3742;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .awards-grid {
    grid-template-columns: 1fr;
  }

  .award-item {
    padding: 8px 10px;
  }

  .award-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}
</style>
